import api from './baseApi';

export enum CouponStatus {
  ACTIVE = 'ACTIVE',
  INACTIVE = 'INACTIVE',
  EXPIRED = 'EXPIRED',
}

export interface Coupon {
  _id: number;
  createdAt: string; // or Date - managed by API
  createdBy?: string; // ObjectId - managed by API
  updatedAt?: string; // or Date - managed by API
  updatedBy?: string; // ObjectId - managed by API

  code: string; // 12-digit alphanumeric excluding IOL10
  status: CouponStatus; // 'ACTIVE' | 'INACTIVE' | 'EXPIRED'
  startDate: string; // or Date if you're directly handling Date objects
  endDate: string; // or Date if you're directly handling Date objects
  max_users: number;
  used_count_total: number;
  tribes: { tribe_id: string; used_count: number }[];
  clientName: string;
  salesNotes?: string;
}

export const couponApi = {
  getCoupons: async (): Promise<Coupon[]> => {
    const axiosResponse = await api.get(`coupons`);
    return axiosResponse.data.result;
  },

  getCouponByCode: async (code: string): Promise<Coupon> => {
    const axiosResponse = await api.get(`coupons/${code}`);
    return axiosResponse.data.result;
  },

  editCoupon: async (
    coupon_id: number,
    data: Partial<Coupon>
  ): Promise<Coupon> => {
    const axiosResponse = await api.patch(`coupons/${coupon_id}`, {
      data,
      // status,
      // max_users,
      // startDate,
      // endDate,
      // clientName,
      // salesNotes
    });
    return axiosResponse.data.result;
  },

  createCoupon: async (
    clientName: string,
    max_users: number,
    startDate: string,
    endDate: string
  ): Promise<Coupon> => {
    // note: can pass in `salesNotes` that'll be private to admins
    const axiosResponse = await api.post(`coupons/`, {
      max_users,
      startDate,
      endDate,
      clientName,
    });
    return axiosResponse.data.result;
  },
};
